import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function can(permissions, path) {
  return path.split(".").reduce((a, k) => (a ? a[k] : undefined), permissions) === true;
}

export default function Sidebar() {
  const { permissions } = useAuth();

  const links = [
    { to: "/", label: "Dashboard", show: can(permissions, "dashboard.view") },
    { to: "/access", label: "Access Management", show: can(permissions, "access.manage") },
    
    { to: "/users", label: "Users", show: can(permissions, "users.view") },
    { to: "/upload", label: "Upload CSV", show: can(permissions, "records.upload") },
    
    { to: "/records", label: "Records", show: can(permissions, "records.view") },
    { to: "/theme", label: "Theme", show: can(permissions, "theme.update") }
  ];

  return (
    <aside className="w-64 hidden md:flex flex-col border-r border-[rgb(var(--border))] bg-[rgb(var(--card))]">
      {/* Brand header */}
      <div className="px-5 py-5 border-b border-[rgb(var(--border))]">
        <div className="flex items-center gap-3">
          <span
            className="w-10 h-10 rounded-xl flex items-center justify-center text-white font-bold text-base shrink-0"
            style={{ background: "rgb(var(--primary))" }}
          >R</span>
          <div>
            <div className="font-bold text-base leading-tight">Ramaa Admin</div>
            <div className="text-xs opacity-40 leading-tight mt-0.5">Management Portal</div>
          </div>
        </div>
      </div>

      <nav className="px-3 py-4 flex flex-col gap-1 flex-1">
        <div className="text-xs font-semibold uppercase tracking-widest opacity-30 px-3 pb-2">Menu</div>
        {links.filter(l => l.show).map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) =>
              "px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors " +
              (isActive
                ? "bg-[rgb(var(--primary))] text-white shadow-sm"
                : "opacity-60 hover:opacity-100 hover:bg-[rgba(var(--primary),0.08)]")
            }
          >
            {l.label}
          </NavLink>
        ))}
      </nav>

      <div className="px-5 py-4 border-t border-[rgb(var(--border))] text-xs opacity-25 text-center">
        Ramaa Group &copy; {new Date().getFullYear()}
      </div>
    </aside>
  );
}